import { SYSTEM_USER } from '@confluence/web-item-location/entry-points/webFragmentLocations';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation';

export const preloadProfileMenu = () => {
	return preloadWebItemLocation({ location: SYSTEM_USER });
};
